//2025.0325修正補足-クッキー操作に使われているのは jQuery Cookie プラグインなので今後改修するべきかも

$(function () {
  const $gotop = $(".p-ft__gotop");
  const $popupBanner = $(".js-popupBanner");
  const $ftSurvey = $(".js-ft__survey");

  // 要素の存在チェック
  const hasGotop = $gotop.length > 0;
  const hasPopupBanner = $popupBanner.length > 0;
  const hasSurvey = $ftSurvey.length > 0;

  // スクロール状態フラグ
  let isScrolledOver100 = false;

  // ===== スクロール時の処理 =====
  if (hasGotop || hasPopupBanner) {
    $(window).on("load scroll", function () {
      const hasScrolled = $(window).scrollTop() > 100;
      const popupBannerClosed = document.cookie.indexOf("flag=true") !== -1;

      if (hasScrolled && !isScrolledOver100) {
        // スクロールが初めて100pxを超えたとき
        isScrolledOver100 = true;

        if (hasGotop) $gotop.addClass("is-show");

        if (hasPopupBanner && !popupBannerClosed) {
          $popupBanner.addClass("UpMove").removeClass("DownMove");
        }
      } else if (!hasScrolled && isScrolledOver100) {
        // スクロール位置が100px未満に戻ったとき
        isScrolledOver100 = false;

        if (hasGotop) $gotop.removeClass("is-show");

        if (hasPopupBanner) {
          $popupBanner.addClass("DownMove").removeClass("UpMove");
        }
      }
    });
  }

  // ===== フッターアンケートの表示処理 =====
  if (hasSurvey) {
    const cookieName = "flagSurvey";
    // クッキーがなければ表示（0.5秒後）
    if (!$.cookie(cookieName)) {
      setTimeout(function () {
        $ftSurvey.addClass("is-loaded");
      }, 500);
    }

    // 閉じるボタンで非表示 + クッキーセット
    $(".flagSurvey-x").on("click", function (event) {
      $ftSurvey.removeClass("is-loaded");
      event.preventDefault();
      $.cookie(cookieName, "true", {
        expires: 1, // 一日後に期限切れ
        path: "/",
      });
    });
  }

  // ===== バナーの共通「閉じる」ボタン処理 =====
  if (hasPopupBanner) {
    $(".flagNormal-x").on("click", function (event) {
      isScrolledOver100 = false;
      event.preventDefault();
      $.cookie("flag", "true", {
        expires: 1, // 一日後に期限切れ
        path: "/",
      });

      $popupBanner.addClass("DownMove").removeClass("UpMove");
    });
  }
});
